import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
// import {
//   useAddReportTypeMutation,
//   useUpdateReportTypeMutation,
// } from "../../Data/services/reportTypeApi";
import ClipLoader from "react-spinners/ClipLoader";
import {
  useAddFaqMutation,
  useUpdateFaqMutation,
} from "../../Data/services/faqApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";

const EditFAQModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [order, setOrder] = useState(0);
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    console.log(editData);
    // console.log(data.slug);
    if (editData) {
      setRowId(editData.id);
      setQuestion(editData.title);
      setAnswer(editData.content);
    }
  }, [editData, mounted]);

  const handleQuestion = (e) => {
    console.log(e.target.value);
    setQuestion(e.target.value);
  };

  const handleAnswer = (e) => {
    console.log(e.target.value);
    setAnswer(e.target.value);
  };

  const handleOrder = async (e) => {
    console.log(e.target.value);
    setOrder(e.target.value);
  };

  const [addFaq, { isLoading: adding }] = useAddFaqMutation();
  const [updateFaq, { isLoading: updating }] = useUpdateFaqMutation();

  const handleSubmit = async (e) => {
    console.log(rowId);

    const data = {
      title: question,
      content: answer,
    };

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updateFaq({ data, id: rowId });
      } else {
        response = await addFaq(data);
      }

      console.log(response);

      if (response.data.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.data.message);
        handleEditModalClose();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer} style={{ minWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit FAQ" : "Add FAQ"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            {
              <Row>
                <Col md={12}>
                  <Input
                    classes="mt-2 mb-3"
                    type="text"
                    name="title"
                    placeholder="Enter title"
                    value={question}
                    onChange={handleQuestion}
                  />
                </Col>
              </Row>
            }
            {
              <Row>
                <Col md={12}>
                  <Input
                    classes="mt-2 mb-3"
                    type="textarea"
                    rows={5}
                    as="textarea"
                    name="content"
                    placeholder="Enter content"
                    value={answer}
                    onChange={handleAnswer}
                  />
                </Col>
              </Row>
            }
            {
              // <Row>
              //   <Col md={12}>
              //     <Input
              //       classes="mt-2 mb-3"
              //       type="number"
              //       name="order"
              //       min={0}
              //       placeholder="Enter order number"
              //       value={order}
              //       onChange={handleOrder}
              //     />
              //   </Col>
              // </Row>
            }

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending || !question || !answer
                      ? "bg-dark-subtle"
                      : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#6457c6" size="22" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending || !question || !answer}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditFAQModal;
